import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HttpApiClient } from "../../axios/axiosInstance";
import {
  fetchArtistByUsername,
  fetchArtistDashboardDetailsService,
  fetchSpotlightArtist,
  fetchTrendingArtist,
  getAllArtist,
  getArtistByCategory,
  getCategories,
  getNotifications,
  getProfilePictue,
  markNotificationRead,
} from "../../services";

const initialState = {
  artists: [],
  totalArtistsByCategory: 0,
  loading: false,
  error: null,
  trendingArtists: [],
  trendingArtistsLoading: false,
  trendingArtistsError: null,
  spotlightArtists: [],
  spotlightArtistsLoading: false,
  spotlightArtistsError: null,
  artistByUsername: [],
  fetchingArtistByUsernameLoading: false,
  fetchingArtistByUsernameErrors: null,
  notifications: [],
  notificationsLoading: false,
  notificationsError: null,
  artistDashboardDetails: [],
  artistDashboardDetailsLoading: false,
  artistDashboardDetailsError: null,
  profilePictureData: null,
  categories: [],
};
export const fetchArtistByCategory = createAsyncThunk(
  "/artistByCategory",
  async (request) => {
    const response = await HttpApiClient.post(getArtistByCategory, request);
    return response.data.data;
  }
);
export const fetchNotifications = createAsyncThunk(
  "/fetchNotifications",
  async (request) => {
    const response = await HttpApiClient.get(getNotifications, request);
    return response.data.data.results;
  }
);

export const fetchTrendingArtists = createAsyncThunk(
  "/fetchTrendingArtists",
  async (request) => {
    const response = await HttpApiClient.post(fetchTrendingArtist, request);
    return response.data.data.results;
  }
);

export const fetchSpotlightArtists = createAsyncThunk(
  "/fetchSpotlightArtists",
  async (request) => {
    const response = await HttpApiClient.post(fetchSpotlightArtist, request);
    return response.data.data;
  }
);

export const getArtistByUsername = createAsyncThunk(
  "/getArtistByUsername",
  async (request) => {
    const response = await HttpApiClient.get(
      `${fetchArtistByUsername}${request.username}`
    );
    return response?.data?.data?.artist;
  }
);

export const getArtistDashboardDetails = createAsyncThunk(
  "/getArtistDashboard",
  async (request) => {
    const response = await HttpApiClient.get(
      fetchArtistDashboardDetailsService
    );
    return response.data.data;
  }
);

export const markReadNotifiications = createAsyncThunk(
  "/markNotificationRead",
  async () => {
    await HttpApiClient.post(markNotificationRead);
  }
);
export const getProfilePicture = createAsyncThunk(
  "/getProfilePicture",
  async (username) => {
    const response = await HttpApiClient.get(
      `${getProfilePictue}userName=${username}`
    );

    return response;
  }
);

export const fetchCategories = createAsyncThunk("/getCategories", async () => {
  const response = await HttpApiClient.post(getCategories);
  return response.data.data;
});

const artistSlice = createSlice({
  name: "artists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })
      .addCase(fetchArtistByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfilePicture.fulfilled, (state, action) => {
        state.profilePictureData = action.payload;
      })

      .addCase(fetchArtistByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.artists = action.payload.results;
        state.totalArtistsByCategory = action.payload.total;
      })
      .addCase(fetchArtistByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTrendingArtists.pending, (state) => {
        state.trendingArtistsLoading = true;
        state.trendingArtistsError = null;
      })
      .addCase(fetchTrendingArtists.fulfilled, (state, action) => {
        state.trendingArtistsLoading = false;
        state.trendingArtists = action.payload;
      })
      .addCase(fetchTrendingArtists.rejected, (state, action) => {
        state.trendingArtistsLoading = false;
        state.trendingArtistsError = action.payload;
      })
      .addCase(fetchSpotlightArtists.pending, (state) => {
        state.spotlightArtistsLoading = true;
        state.spotlightArtistsError = null;
      })
      .addCase(fetchSpotlightArtists.fulfilled, (state, action) => {
        state.spotlightArtistsLoading = false;
        state.spotlightArtists = action.payload;
      })
      .addCase(fetchSpotlightArtists.rejected, (state, action) => {
        state.spotlightArtistsLoading = false;
        state.spotlightArtistsError = action.payload;
      })

      .addCase(getArtistByUsername.pending, (state) => {
        state.fetchingArtistByUsernameLoading = true;
        state.fetchingArtistByUsernameErrors = null;
      })
      .addCase(getArtistByUsername.fulfilled, (state, action) => {
        state.fetchingArtistByUsernameLoading = false;
        state.artistByUsername = action.payload;
      })
      .addCase(getArtistByUsername.rejected, (state, action) => {
        state.fetchingArtistByUsernameLoading = false;
        state.fetchingArtistByUsernameErrors = action.payload;
      })
      .addCase(fetchNotifications.pending, (state) => {
        state.notificationsLoading = true;
        state.notificationsError = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.notificationsLoading = false;
        state.notifications = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.notificationsLoading = false;
        state.notificationsError = action.payload;
      })
      .addCase(getArtistDashboardDetails.pending, (state) => {
        state.artistDashboardDetailsLoading = true;
        state.artistDashboardDetailsError = null;
      })
      .addCase(getArtistDashboardDetails.fulfilled, (state, action) => {
        state.artistDashboardDetailsLoading = false;
        state.artistDashboardDetails = action.payload;
      })
      .addCase(getArtistDashboardDetails.rejected, (state, action) => {
        state.artistDashboardDetailsLoading = false;
        state.artistDashboardDetailsError = action.payload;
      });
  },
});

export default artistSlice.reducer;
